
import {midiDispatcher} from 'src/modules/midi/MidiDispatcher';
import {Component, Mixins, Prop, Vue} from 'vue-property-decorator';

import Key from './models/Key';
import {Division} from '../../playable/models/Division';
import { KEYBOARD_DATA } from './models/Keyboard';

@Component
export default class Keyboard{
  @Prop({default: 1}) minNote: number;
  @Prop({default: 69}) maxNote: number;
  @Prop({default: false}) isInteractive: boolean;
  @Prop({default: true}) showError: boolean;
  @Prop({default: () => []}) rangeToDisplay: any;

  @Prop({default: true}) displayLeftHand: boolean;
  @Prop({default: true}) displayRightHand: boolean;
  @Prop({default: false}) displayNextHandprint: boolean;
  @Prop({default: true}) centered: boolean;

  @Prop({default: null}) currentDivision: Division | null;

  @Prop({default: () => []}) highlightedKeys: number[]
  @Prop({default: false}) isKeySelectable: boolean
  @Prop({default: false}) noValidationColors: boolean

  get actualKeyboardData() {
    return KEYBOARD_DATA.filter((key) => key.id >= this.minNote - 1 && key.id < this.maxNote);
  }

  /* CSS Linked */
  get widthNote() {
    return 100 / (this.maxNote - this.minNote + 1 - this.numBlackKeys);
  }
  get numBlackKeys() {
    return this.actualKeyboardData[this.actualKeyboardData.length -1].numBlackKeysBefore - this.blackKeysBeforeMinNoteQuantity;
  }
  get blackKeysBeforeMinNoteQuantity() {
    return this.actualKeyboardData[0].numBlackKeysBefore;
  }

  get keyboard() {
    return this.actualKeyboardData.map((key) => {
      const isActive = this.isInteractive && (midiDispatcher.state.activeKeys.includes(key.id));
      const inRange = this.rangeToDisplay.includes(key.id);
      const isHighlighted = this.highlightedKeys.includes(key.id);
      return new Key(this.currentDivision, isActive, inRange, key, isHighlighted);
    })
  }

  /* Key CSS Compute */
  getKeyWidthStyleAttribute(key: Key) {
    return key.type === 'white' ? this.widthNote + '%' : this.widthNote / 1.8 + '%';
  }
  getKeyLeftStyleAttribute(key: Key) {
    const keyOffset = key.id - this.minNote;
    const backKeyOffset = key.numBlackKeysBefore - this.blackKeysBeforeMinNoteQuantity;
  
    return key.type === 'white'
      ? (keyOffset - backKeyOffset + 1) * this.widthNote + '%'
      : (keyOffset - backKeyOffset) * this.widthNote + this.widthNote / 1.4 + '%';
  }
  get keyboardplayClass() {
    return [
      'keyboard',
      'keyboard--show-left-hand-' + this.displayLeftHand,
      'keyboard--show-right-hand-' + this.displayRightHand,
      'keyboard--show-next-print-left-' + (this.displayNextHandprint && this.displayLeftHand),
      'keyboard--show-next-print-right-' + (this.displayNextHandprint && this.displayRightHand),
      'keyboard--centered-' + this.centered,
      'keyboard--show-error-' + this.showError,
    ];
  }
  getKeyplayClass(key: Key) {
    return [
      'keyboard__key',
      'keyboard__key--' + key.type,
      'keyboard__key--hand-' + key.currentNote.hand,
      'keyboard__key--action-' + key.currentNote.noteStatus,
      'keyboard__key--position-' + key.position.hand,
      'keyboard__key--midi-active-' + key.isActive,
      'keyboard__key--midi-in-range-' + key.inRange,
      'keyboard__key--nextprint-hand-' + key.nextNote?.hand,
      'keyboard__key--highlighted-' + key.isHighlighted,
      this.noValidationColors ? '' : 'keyboard__key--validation-colors',
    ];
  }
}
